import React from 'react';
import { IProps } from '../../domain/model';
import UserContractStatusDetail from '../../components/admin/statusMgmt/userContractStatusDetail';

export default function userContractStatusMgmtDetailPage({ state }: IProps): JSX.Element {
  return (
    <>
      {!state.loading && (
        <>
          <UserContractStatusDetail state={state} />
        </>
      )}
    </>
  );
}
